import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { NotificationsService } from 'angular2-notifications';

import { ResourcesService } from '../../../../services/resources/resources.service';
import { EventsService } from '../../../../services/events/events.service';
import { SERVICES_URLS } from '../../../../services/resources/services.urls';
import { LocalStorageService } from 'ngx-webstorage';

import * as moment from 'moment-timezone';

@Component({
  selector: 'modal-import-rh',
  styleUrls: [('./modalImportRH.scss')],
  templateUrl: './modalImportRH.html'
})

export class ModalImportRH {
  @ViewChild('form') form;
  modalHeader: string;
  survey;
  folder: string = "";
  loading: Boolean;
  private fileList: FileList;
  private user: string = "";
  private user_id;
  private base64textString: String = "";
  fileExtensionMessage = "";
  fileExtensionError = false;

  constructor(
    private activeModal: NgbActiveModal,
    private _notificationService: NotificationsService,
    private _resourcesService: ResourcesService,
    private _element: ElementRef,
    private _localStorage: LocalStorageService,
    private _eventsService: EventsService
  ) {
    var user = _localStorage.retrieve('user_data');
    if (user != null)
      this.user = user;

    this.user_id = user.id;
    _localStorage.observe('user_data')
      .subscribe((token) => this.user = token);

  }

  ngOnInit() { }

  public closeModal() {
    this.activeModal.close();
  }

  public importarRH() {
    this.loading = true;
    var id_user = ('000' + this.user_id).slice(-4);
    if (this.fileList != null && this.fileList.length > 0) {
      this._resourcesService.ImportExcelRegistosHorarios(this.fileList, id_user)
        .subscribe(
        (result) => {
            this._notificationService.success('Mensaje', 'La importación finalizó con éxito.');
            this.saveSurvey(result);            
          },
        (error) => {
            this.getDataError(error);
          }
        );
    }
    else {
      this.loading = false;
      this._notificationService.warn('Mensaje', 'No se seleccionó ningún archivo.');
    }
  }

  public uploadImage() {

  }

  private showError(error) {
    this._notificationService.error('Mensaje', 'Error con los datos ingresados. Revise si los datos del dni ya existen');
  }

  private saveSurvey(survey) {
    this._eventsService.setObjectCrud(survey);
    this.activeModal.close();
  }

  public selectFile() {
    this.fileList = null;
  }


  public fileChange(event) {
    var allowedExtensions = ["xlsx", "xls", "XLSX", "XLS"];
    var files = event.target.files;
    var file = files[0];
    var photoName = file.name;
    var fileExtension = photoName.split('.').pop();
    if (this.isInArray(allowedExtensions, fileExtension)) {
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""
    } else {
      this.fileExtensionMessage = "solo archivos excel son permitidos xlsx, xls"
      this.fileExtensionError = true;
    }

    this.fileList = event.target.files;
  }

  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }


  private getDataError(error) {
    console.log(error);
    this.loading = false;
    this.form.nativeElement.reset();
    this._notificationService.error('Mensaje', 'Error al Importar los Registros Horarios. '+ error);
  }
}



// WEBPACK FOOTER //
// /app/src/app/theme/components/modals/components/modalImportRH/modalImportRH.component.ts